export default __webpack_public_path__ + "static/media/Sun.f9825601.svg";